import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

export type CardPadding = 'none' | 'sm' | 'md' | 'lg';
export type CardElement = 'div' | 'section' | 'article' | 'li';

export interface CardProps extends HTMLAttributes<HTMLElement> {
  /** none 0, sm 16px, md 20px (default), lg 24px. */
  padding?: CardPadding;
  /** Warm surface instead of white. */
  tone?: 'default' | 'warm';
  as?: CardElement;
  children?: ReactNode;
}

/** Quiet white card: surface, hairline border, 20px radius, soft shadow. */
export function Card({
  padding = 'md',
  tone = 'default',
  as: Element = 'div',
  className,
  children,
  ...rest
}: CardProps) {
  return (
    <Element
      {...rest}
      className={cx(
        'ee-card',
        `ee-card--pad-${padding}`,
        tone === 'warm' && 'ee-card--warm',
        className,
      )}
    >
      {children}
    </Element>
  );
}
